/**
 * Envía una acción de estado del traslado (iniciar, finalizar, fallido) y, si la red falla sin
 * respuesta del servidor, la repite una vez. El servidor responde éxito si la acción ya se había
 * guardado (ya_iniciado / ya_finalizado / ya_marcado), así que el reintento también confirma el
 * estado real cuando se perdió la respuesta, sin duplicar el cambio.
 */
export async function putConReintento(api, url, payload, { esperaMs = 2000, timeout = 30000 } = {}) {
  try {
    return await api.put(url, payload, { timeout });
  } catch (error) {
    if (error.response) throw error;
    await new Promise((resolve) => setTimeout(resolve, esperaMs));
    return api.put(url, payload, { timeout });
  }
}

/** Mensaje para el conductor cuando no se pudo confirmar la acción con el servidor */
export function mensajeErrorAccion(error, porDefecto) {
  if (!error?.response) {
    return "No se pudo confirmar con el servidor. Revise la conexión e intente de nuevo: si ya quedó registrado, el sistema lo reconocerá.";
  }
  return error.response.data?.error || error.response.data?.message || porDefecto;
}
